// Base de entidades DXCC (~262). Os dados moram em shared/dxcc.json, que o
// backend tambem le — manter duas copias foi o que dessincronizou a pontuacao
// do DX Marathon (ticket #15). Formato: [px, entidade, continente, zonaCQ, zonaITU].
import DXCC_JSON from '../../shared/dxcc.json';

export const DXCC_RAW = DXCC_JSON;

// Full DXCC entity list for tracker UI
export const DXCC_LIST = DXCC_RAW.map(function(d) { return { px: d[0], entity: d[1], cont: d[2], cq: d[3], itu: d[4] }; });
